module.exports = __webpack_public_path__ + "img/slogen-fr.98926968.svg";